const REGEX_LEGACY_CLIENT_ROUTE_PATTERN = /#\/\d+\/M[1,2](?:\/Ls)?\/T(\w|-)+\//

export const isLegacyUrl = url => REGEX_LEGACY_CLIENT_ROUTE_PATTERN.test(url)
